import { render } from "./NcrmBoard.vue?vue&type=template&id=4bc87698&scoped=true"
import script from "./NcrmBoard.vue?vue&type=script&lang=js"
export * from "./NcrmBoard.vue?vue&type=script&lang=js"

import "./NcrmBoard.vue?vue&type=style&index=0&id=4bc87698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc87698"]])

export default __exports__